'use client';

import { motion, AnimatePresence } from 'framer-motion';
import { useMemo } from 'react';

export function FeedbackBubble({ text }: { text: string }) {
  const side = useMemo<'left' | 'right'>(
    () => (Math.random() > 0.5 ? 'left' : 'right'),
    [text]
  );

  const rotation = useMemo(() => {
    const base = 4 + Math.random() * 4;
    return side === 'left' ? -base : base;
  }, [side]);

  const exitX = side === 'left' ? -30 : 30;

  return (
      <motion.div
        key={text}
        initial={{
          opacity: 0,
          scale: 0.6,
          y: 20,
          rotate: rotation,
        }}
        animate={{
          opacity: 1,
          scale: 1,
          y: 0,
          rotate: 0,
        }}
        exit={{
          opacity: 0,
          scale: 0.85,
          y: -12,
          x: exitX,
          filter: 'blur(4px)',
        }}
        transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1],
        }}
        className={`
          pointer-events-none
          absolute
          top-1/2 -translate-y-1/2
          z-40
          ${side === 'left' ? 'left-[calc(50%-230px)]' : 'right-[calc(50%-230px)]'}
        `}
      >
        <div
          className="
            relative
            max-w-[220px]
            rounded-2xl
            bg-white
            px-5 py-2
            text-sm font-bold
            text-neutral-900
            border-2 border-black
            shadow-[0_14px_36px_rgba(0,0,0,0.35)]
          "
        >
          {text}

          <span
            className={`
              absolute -bottom-2
              h-4 w-4
              bg-white
              border-b-2 border-r-2 border-black
              rotate-45
              ${side === 'left' ? 'left-6' : 'right-6'}
            `}
          />
        </div>
      </motion.div>
  );
}
